/**
 * OrbDocReferenceOperatorsSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocReferenceOperatorsSLDocScreen
 */

import { useOrbDocReferenceOperatorsSLDocScreenLogic } from '@/hooks/traits/useOrbDocReferenceOperatorsSLDocScreenLogic';
import type { OrbDocReferenceOperatorsSLDocScreenConfig } from '@/hooks/traits/useOrbDocReferenceOperatorsSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocReferenceOperatorsSLDocView as OrbDocReferenceOperatorsSLDocViewEntity } from '@app/shared';
import { OrbDocReferenceOperatorsSLDocBodyView } from '@/components/traits/OrbDocReferenceOperatorsSLDocBodyView';
import { OrbDocReferenceOperatorsSLDocFooterView } from '@/components/traits/OrbDocReferenceOperatorsSLDocFooterView';
import { OrbDocReferenceOperatorsSLDocHeaderView } from '@/components/traits/OrbDocReferenceOperatorsSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocReferenceOperatorsSLDocScreenViewProps {
  config?: Partial<OrbDocReferenceOperatorsSLDocScreenConfig>;
}

export function OrbDocReferenceOperatorsSLDocScreenView({ config: propsConfig }: OrbDocReferenceOperatorsSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocReferenceOperatorsSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocReferenceOperatorsSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocReferenceOperatorsSL" trait="OrbDocReferenceOperatorsSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocReferenceOperatorsSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocReferenceOperatorsSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceOperatorsSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocReferenceOperatorsSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocReferenceOperatorsSLDocScreenView;
